import { Card, ListGroup } from "react-bootstrap";
import "./Menu.css";

const desserts = [
  {
    name: "Schwarzwaelder Kirschtorte",
    description: "",
  },
  {
    name: "Kaffee",
    description: "No. 15 Brasilien; Dona Sa - Simone",
  },
  {
    name: "Cappuccino",
    description: "Milch, Hafermilch",
  },
];

export function DessertMenu() {
  return (
    <Card className="mb-4 menu-card">
      <Card.Header as="h5">Dessert</Card.Header>
      <ListGroup variant="flush">
        {desserts.map((dessert) => (
          <ListGroup.Item key={dessert.name} className="menu-list-item">
            <strong>{dessert.name}</strong>
            {dessert.description && (
              <p className="mb-0 text-muted">{dessert.description}</p>
            )}
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Card>
  );
}
